import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const [country, setCountry]   = useState(null);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    // Load active country list and default config on mount
    Promise.all([
      api.get('/countries'),
      api.get('/countries/default'),
    ]).then(([listRes, defaultRes]) => {
      setCountries(listRes.countries || []);
      setCountry(defaultRes.country || null);
    }).catch(() => {
      // silently fall back — app still works without country config
    }).finally(() => setLoading(false));
  }, []);

  const selectCountry = async (code) => {
    try {
      const res = await api.get(`/countries/${code}`);
      setCountry(res.country);
      return res.country;
    } catch {
      return null;
    }
  };

  return (
    <CountryContext.Provider value={{ country, countries, loading, selectCountry, setCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  return useContext(CountryContext);
}
